/* Stravian: substring product search overlay.
 * Shopify's native predictive search (search/suggest.json) is fuzzy /
 * relevance-ranked, not substring matching — a query like "m" reliably
 * dropped products that plainly contain that letter (e.g. Magnesium+
 * itself) because they didn't rank in the server's top results, and that
 * ranking isn't tunable from theme code. `settings.enable_predictive_search`
 * is off (see config/settings_data.json) so Shopify's own fetch never runs;
 * this does a simple client-side substring match against the full catalog
 * (snippets/stravian-search-catalog.liquid) instead and renders straight
 * into the same results panel — image, name, link to the PDP.
 */
(function () {
  var catalog = null;

  function getCatalog() {
    if (catalog) return catalog;
    var el = document.getElementById('sl-search-catalog');
    if (!el) { catalog = []; return catalog; }
    try {
      catalog = JSON.parse(el.textContent);
    } catch (e) {
      catalog = [];
    }
    return catalog;
  }

  // Shared with stravian-motion.js's bottom-nav search (initInlineSearch),
  // which uses the same substring match against the same catalog but
  // renders into its own, differently-styled panel markup.
  window.SLGetSearchCatalog = getCatalog;

  function buildItem(product) {
    var li = document.createElement('li');
    li.className = 'search-result-list__item';
    li.setAttribute('role', 'option');

    var a = document.createElement('a');
    a.href = product.url;
    a.className = 'suggest-item';

    if (product.image) {
      var figure = document.createElement('figure');
      figure.className = 'wt-cart__item__thumb suggest-item__thumb';
      var img = document.createElement('img');
      img.src = product.image;
      img.loading = 'lazy';
      img.alt = product.title;
      figure.appendChild(img);
      a.appendChild(figure);
    }

    var body = document.createElement('div');
    body.className = 'wt-cart__item__body suggest-item__body';
    var data = document.createElement('div');
    data.className = 'wt-cart__item__data';
    var name = document.createElement('h3');
    name.className = 'wt-cart__item__name';
    name.textContent = product.title;
    data.appendChild(name);
    body.appendChild(data);
    a.appendChild(body);

    li.appendChild(a);
    return li;
  }

  function render(container, matches) {
    container.innerHTML = '';
    var wrap = document.createElement('div');
    wrap.id = 'predictive-search-results';
    wrap.className = 'search-result' + (matches.length === 0 ? ' search-result--no-results' : '');

    if (matches.length > 0) {
      var section = document.createElement('div');
      section.className = 'search-result-products';

      var title = document.createElement('div');
      title.id = 'predictive-search-products';
      title.className = 'search-result__title';
      title.textContent = 'Products';
      section.appendChild(title);

      var ul = document.createElement('ul');
      ul.id = 'predictive-search-results-list';
      ul.className = 'search-result-list';
      ul.setAttribute('role', 'listbox');
      ul.setAttribute('aria-labelledby', 'predictive-search-products');
      matches.slice(0, 10).forEach(function (product) {
        ul.appendChild(buildItem(product));
      });
      section.appendChild(ul);
      wrap.appendChild(section);
    }

    container.appendChild(wrap);
  }

  function handleInput(event) {
    var input = event.target;
    var root = input.closest('search-drawer') || document;
    var container = root.querySelector('[data-predictive-search]');
    if (!container) return;

    setTimeout(function () {
      var query = (input.value || '').trim().toLowerCase();
      if (!query) return;
      var matches = getCatalog().filter(function (product) {
        return product.title.toLowerCase().indexOf(query) !== -1;
      });
      render(container, matches);
    }, 120);
  }

  document.addEventListener('input', function (event) {
    if (event.target && event.target.matches && event.target.matches('input[name="q"]')) {
      handleInput(event);
    }
  }, true);
})();
